import { Component, OnInit, Inject } from '@angular/core';
import {
  CampusUnitsCommunicationsDataService,
  CampusUnitsFaqSection,
  ConfirmDialog
} from '../../../shared';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-new-section-dialog',
  templateUrl: './new-section-dialog.component.html',
  styleUrls: ['./new-section-dialog.component.scss']
})
export class NewSectionDialogComponent implements OnInit {
  sectionsForm: FormGroup;
  sections: CampusUnitsFaqSection[] = [];
  savingChanges = false;
  deletingSection = false;
  addNewSection = false;
  newSection: CampusUnitsFaqSection;
  emptySections: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private communicationsDataService: CampusUnitsCommunicationsDataService,
    private matDialog: MatDialog,
    private formBuilder: FormBuilder
  ) {
    this.sections = data.sections;
  }

  ngOnInit() {
    const group: any = {};
    if (this.sections.length > 0) {
      this.emptySections = false;
    } else {
      this.emptySections = true;
      this.showAddSectionInput();
    }
    for (const section of this.sections) {
      group[section.campusUnitsFaqSectionId] = new FormControl(section.name);
    }
    this.sectionsForm = new FormGroup(group);
    this.newSection = new CampusUnitsFaqSection();
  }

  save() {
    this.savingChanges = true;
    if (this.addNewSection) {
      this.saveNewSection();
    } else {
      for (const s of this.sections) {
        s.name = this.sectionsForm.controls[s.campusUnitsFaqSectionId].value;
      }
      this.communicationsDataService
        .updateSections(this.sections)
        .subscribe(() => {
          this.savingChanges = false;
          this.matDialog.closeAll();
        });
    }
  }

  deleteSection(sectionId: number) {
    this.deletingSection = true;
    this.communicationsDataService.deleteSection(sectionId).subscribe(() => {
      this.deletingSection = false;
      this.matDialog.closeAll();
    });
  }

  openDeleteDialog(section: CampusUnitsFaqSection) {
    const message =
      'Are you sure you want to delete "' + section.name + '" section?';
    const confirmDialog = this.openConfirmDialog(message);
    confirmDialog.afterClosed().subscribe(response => {
      if (response) {
        this.deleteSection(section.campusUnitsFaqSectionId);
      }
    });
  }

  private openConfirmDialog(message: string): MatDialogRef<ConfirmDialog, any> {
    return this.matDialog.open(ConfirmDialog, {
      autoFocus: false,
      data: { title: 'Delete Confirmation', message: message }
    });
  }

  showAddSectionInput() {
    if (this.addNewSection) {
      this.addNewSection = false;
    } else {
      this.addNewSection = true;
    }
  }

  saveNewSection() {
    this.communicationsDataService
      .createSection(this.newSection)
      .subscribe(() => {
        this.addNewSection = false;
        this.matDialog.closeAll();
      });
  }
}
